import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-edit\"><title>icon_画板</title><polygon points=\"10.09 22.58 11.93 17.42 14.93 20.57 10.09 22.58\" /><polygon points=\"15.54 19.98 12.52 16.8 20.74 8.24 23.77 11.41 15.54 19.98\" /><path d=\"M24.33,10.75l-3-3.17L22.82,6a1.24,1.24,0,0,1,1.82,0l1.21,1.27a1.4,1.4,0,0,1,0,1.91Z\" /><path d=\"M27.41,28.42H6.6a1.14,1.14,0,1,1,0-2.28H27.41a1.14,1.14,0,0,1,0,2.28Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol